import React from "react";
import * as Styles from "./footer.styles";
import { Content } from "../content";
import { Spacer } from "../spacer";
import { Text } from "../text";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Content variant="secondary">
      <Spacer height={3} />
      <Styles.Details>
        <Text>&copy; {year}</Text>
        <Text>
          WVS India is an independent registered Indian Trust (Reg No. 79/2010),
          recognised by Animal Welfare Board of India (Reg no TN195/2015).
        </Text>
        <Styles.Link href="/cookies" title="Cookies">
          Cookies
        </Styles.Link>
      </Styles.Details>
    </Content>
  );
};
